import React from "react";
import howitworks from '../../src/assets/videos/howitworks.mp4'
import { Link } from "react-router-dom";
const HowItWorks = () =>{
    return(
        <div class="container mt-5">
                <div style={{ display: 'flex', alignItems: 'center',marginBottom:30 }}>
                      <Link to="/AiResumeInsights">
                        <i className="fa  fa-arrow-left" style={{ color: "#00a7ac", fontSize: 16, marginRight: '10px' }} aria-hidden="true"></i>
                      </Link>
                      <h2 style={{ color: "#00a7ac", marginBottom: '0', marginTop: '0' }}>How it Works</h2>
                    </div>
                    <hr/>
                  <div className="row mt-3"></div>
        <div class="card" >
          <video controls style={{height:500}}>
            <source src={howitworks} type="video/mp4"/>
            Your browser does not support the video tag.
          </video>
          </div>
          </div>

    )
}
export default HowItWorks;